<template>
  <div>
    <el-divider></el-divider>
    <div style="padding-top:8px">
      <el-radio-group v-model="map" @input="change" :size="size">
        <el-radio label="Baidu Map"></el-radio>
        <el-radio label="Google Map"></el-radio>
      </el-radio-group>
      
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      map:"Baidu Map",
    }
  },
  mounted(){
    this.getMap();
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
  },
  methods:{
    change(){
      // console.log(this.map);
      this.$api.setTemplateConfigApp({
        TemplateType: 1,
        Note:this.map,
      })
        .then((res)=>{
          if(res.code == 200){
            this.$message.success(this.$t("public.edit_success"));
          }else{
            this.$message.warning(this.$t("PersonalizedConfig.保存失败，请重试"));
            this.getMap();
          }
        })
    },
    getMap(){
      this.$api.queryTemplateConfigApp({})
        .then((res)=>{
          if(res.code == 200){
            this.map = res.data.MapType;
            if(this.map == ""){
              this.map = "Baidu Map";
            }
          }
        })
        .catch((e)=>{
          
        })
    },
  }
}
</script>
<style scoped>
input[aria-hidden=true] {
	display: none !important;
}
</style>